const DeleteAccount = () => {
    return (
        <div className="p-3">
            <h1>Delete Account</h1>
            <p>1. Sign in to the Fernandes Driver Game with your account.</p>
            <p>2. Once you are redirected to the home screen, click on the setting button located on the top right of the screen.
            </p>
            <p>3. Click on the "DELETE ACCOUNT" button.
            </p>
            <p>4. You will see the attention window then click on "OK DELETE" button.
            </p>
            <p>5. Your account will be deleted scuccesfully.
            </p>



        </div>
    );
};


export default DeleteAccount;
